import React from "react";
import { CCard, CTooltip } from "@coreui/react";
import "./Card.scss";
import { Colors } from "utils";

const Card = ({
  title = "",
  noPadding = false,
  style = {},
  footer,
  className,
  children,
  showTooltip = false,
  tooltipContent 
}) => {
  return (
    <CCard
      className={`my_card ${className}`}
      style={{ ...style, padding: noPadding ? 0 : "1rem" }}
    >
      <div className="mb-2 ml-1 d-flex align-items-center" style={{ fontWeight: "600", gap: '10px' }}>
        <span>
          {title}</span>
        {showTooltip && <CTooltip content={tooltipContent}  placement="top"  style={{
          maxWidth : '400px'
        }}>
          <div
            style={{
              width: "18px",
              height: "18px",
              color: Colors._white,
              background: '#303E4F',
              borderRadius: "50%",
              textAlign: "center",
            }}
            className="d-flex justify-content-center align-items-center"
            title={title}
          >
           !
          </div>
        </CTooltip>}
      </div>
      <div style={{ height: "inherit" }}>{children}</div>
      <div style={{ height: "auto" }}>{footer}</div>
    </CCard>
  );
};

export default Card;
